import { render } from "./formOrdine.html?vue&type=template&id=676c6c69&scoped=true&external"
import script from "./FormOrdine.vue?vue&type=script&lang=js"
export * from "./FormOrdine.vue?vue&type=script&lang=js"

import "./FormOrdine.vue?vue&type=style&index=0&id=676c6c69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676c6c69"]])

export default __exports__